import type { RenewalAlert } from '@policyvision/contracts';

export type { RenewalAlert };

export const RenewalAlertList: RenewalAlert[] = ['MARC', 'ANL', 'RMEV'];
